import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { FieldList, JobForm } from '../../';

const copy = obj => (JSON.parse(JSON.stringify(obj)));

class JobModify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      job: undefined,
      dirty : false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    this.props.fetchJobsFilters();
    this.setState({ job: this.props.job });
  }
  componentDidUpdate() {
    if(this.props.job.updated_timestamp != this.state.job.updated_timestamp) {
      this.setState({ job : copy(this.props.job) });
    }
  }
  handleChange(value, name) {
    let copy_state = copy(this.state.job);
    let entity = copy_state;
    let names = name.split('.'); //address.street
    //names = ['address','street']
    while(names.length > 1) {
      let name = names.shift(); //name = address, names = ['street']
      if(!entity[name]) { //entity[name] = true
        entity[name] = {}; //
      }
      entity = entity[name];
    }

    entity[names.shift()] = value;
    this.setState({job : copy_state, dirty : true});
  }
  handleSave() {
    const { job } = this.state;
    this.props.onSave();
    this.props.sendSocketEmit({
      job,
    }, 'update-job')
  }
  render() {
    let { available_filters } = this.props.jobs;
    let fields = [
      {
        _id: 1,
        flex: 12,
        label: 'Category',
        name: 'category',
        type: 'select',
        options: available_filters
          .filter(({type}) => type == 'category')
          .map(({value}) => ({ label : value, value })),
        placeholder: 'Select Job Category'
      }, {
        _id: 2,
        flex: 12,
        label: 'Work Type',
        name: 'work_type',
        type: 'multiselect',
        options: available_filters
          .filter(({type}) => type == 'work_type')
          .map(({value}) => ({label : value, value})),
        placeholder: 'Select Work Type'
      }, {
        _id : 3,
        flex : 12,
        label : 'Trade',
        name : 'trade',
        type : 'multiselect',
        placeholder: 'Select a trade.',
        options : available_filters
          .filter(({type}) => type == 'trade')
          .map(({value}) => ({label : value, value})),
      }, {
        _id: 6,
        flex: 6,
        label: 'Estimated Price',
        name: 'estimate',
        type: 'text',
        placeholder: '0.00'
      }, {
        _id: 10,
        flex: 6,
        label: 'Final Price',
        name: 'price',
        type: 'currency',
        placeholder: '0.00'
      }, {
        _id: 7,
        flex: 6,
        label: 'Claim Number',
        name: 'claim_number',
        type: 'text',
        placeholder: 'Claim #'
      }, {
        _id: 8,
        flex: 6,
        label: 'Insurance Company',
        name: 'insurance_company',
        type: 'text',
        placeholder: 'Farmers, Allstate, Geico'
      }, {
        _id: 9,
        flex: 12,
        label: 'Description',
        name: 'description',
        type: 'textarea',
        placeholder: 'Description of required work'
      }
    ];

   return (
        <div className='clearfix'>
          <div className="mb-sm">
            <JobForm
              readOnly={this.props.readOnly}
              fields={fields}
              entity={this.state.job}
              onChange={this.handleChange}
            />
          </div>
          {!this.props.readOnly? <div onClick={this.handleSave} className="btn btn-success pull-right"><i className="fa fa-save"></i> Save</div> :''}
        </div>
      );
  }
}

JobModify.propTypes = {

}

const mapStateToProps = ({jobs}) => ({jobs});

export default connect(mapStateToProps, Actions)(JobModify);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-modify.js